export default {
  // Navigation
  'nav.timer': 'Timer',
  'nav.stopwatch': 'Stopwatch',
  'nav.worldclock': 'World Clock',
  'nav.timestamp': 'Timestamp',
  'nav.home': 'Home',
  
  // Common buttons and actions
  'button.start': 'Start',
  'button.pause': 'Pause',
  'button.stop': 'Stop',
  'button.reset': 'Reset',
  'button.ok': 'OK',
  'button.cancel': 'Cancel',
  'button.close': 'Close',
  'button.save': 'Save',
  'button.delete': 'Delete',
  'button.edit': 'Edit',
  'button.back': 'Back',
  'button.next': 'Next',
  'button.previous': 'Previous',
  'button.submit': 'Submit',
  'button.confirm': 'Confirm',
  'button.convert': 'Convert',
  'button.copy': 'Copy',
  'button.copied': 'Copied!',
  'button.now': 'Now',
  'button.clear': 'Clear',
  
  // Common labels
  'label.hours': 'Hours',
  'label.minutes': 'Minutes',
  'label.seconds': 'Seconds',
  'label.milliseconds': 'Milliseconds',
  'label.minute': 'Minute',
  'label.second': 'Second',
  'label.sound': 'Sound',
  'label.soundAlert': 'Sound',
  'label.fullscreen': 'Fullscreen',
  'label.language': 'Language',
  'label.selectLanguage': 'Select Language',
  'label.languageSelectorInfo': 'در حال حاضر از {{count}} زبان پشتیبانی می‌کند. زبان ترجیحی خود را از گزینه‌های بالا انتخاب کنید.',
  
  // Common messages
  'message.timerComplete': 'Timer Complete!',
  'message.timerCompleteDesc': 'Your timer has finished',
  'message.timerCompleteBody': 'Your countdown timer has finished!',
  'message.stopwatchStarted': 'Stopwatch Started',
  'message.stopwatchStartedDesc': 'Stopwatch timing has started',
  'message.stopwatchStopped': 'Stopwatch Stopped',
  'message.stopwatchStoppedDesc': 'Stopwatch timing has been paused',
  'message.stopwatchReset': 'Stopwatch Reset',
  'message.stopwatchResetDesc': 'Stopwatch has been reset to zero',
  'message.notificationPermission': 'Allow notifications to get alerts when timer finishes',
  'message.clickToEdit': 'Click time numbers to directly edit time',
  'message.addHours': '+ Add Hours',
  'message.escToExit': 'Press ESC to exit fullscreen',
  'message.timeRemaining': '{{minutes}} minutes {{seconds}} seconds remaining',
  'message.minutesRemaining': '{{minutes}} minutes remaining',
  'message.secondsRemaining': '{{seconds}} seconds remaining',
  'message.stopwatchTimeElapsed': '{{minutes}} minutes {{seconds}} seconds elapsed',
  'message.stopwatchMinutesElapsed': '{{minutes}} minutes elapsed',
  'message.stopwatchSecondsElapsed': '{{seconds}} seconds elapsed',
  'message.invalidTimestamp': 'Invalid timestamp',
  'message.invalidDateTime': 'Invalid date time',
  'message.conversionError': 'Conversion error',
  
  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'Now',
  'time.today': 'Today',
  'time.yesterday': 'Yesterday',
  'time.tomorrow': 'Tomorrow',
  
  // Common errors
  'error.pageNotFound': 'Page Not Found',
  'error.somethingWrong': 'Something went wrong',
  'error.tryAgain': 'Please try again later',
  
  // Footer
  'footer.about': 'About timer.today',
  'footer.aboutDesc': 'timer.today is a professional online timing tool platform providing three core features:',
  'footer.timerDesc': 'Customizable countdown tool supporting minute and hour settings, perfect for work focus, cooking timing, study management and more. Features sound alerts and desktop notifications.',
  'footer.stopwatchDesc': 'High-precision timing tool with millisecond accuracy, suitable for sports training, cooking operations, exam practice and other scenarios requiring precise timing.',
  'footer.worldClockDesc': 'Real-time display of major city times worldwide with intelligent time zone calculations, facilitating international business communication and cross-timezone collaboration.',
  'footer.timestampDesc': 'Unix timestamp converter supporting bidirectional conversion between timestamp and datetime, with both seconds and milliseconds format support.',
  'footer.termsOfService': 'Terms of Service',
  'footer.privacy': 'Privacy',
  'footer.contactUs': 'Contact Us',
  'footer.changeLanguage': 'change language',
  'footer.moreLanguage': 'more language',
  'footer.copyright': '© timer.today 2024',
  
  // Quick actions
  'quick.add30s': '+30s',
  'quick.add1min': '+1 Min',
  'quick.add5min': '+5 Min',
  'quick.add10min': '+10 Min',
  'quick.add30min': '+30 Min',
  
  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}} Minute Timer',
  'breadcrumb.timer': 'Timer',
  'breadcrumb.stopwatch': 'Stopwatch',
  'breadcrumb.worldClock': 'World Clock',
  'breadcrumb.termsOfService': 'Terms of Service',
};